<div class="table-wrapper">
    <div>
        <aumico-button (click)="onCreatePressed()">Add new Financial Line Item</aumico-button>
    </div>

    <settings-financial-line-item-list-component
        [data]="data"
        [languages]="languages"
        (editPressed)="editPressedEventHandler($event)"
    >
    </settings-financial-line-item-list-component>
</div>
